// generated from 2_804 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const e164PhoneNumberFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("e164_phone_number_filter"),
  comparison_key: z.enum([
    "11", // 1_966 (70.11%)
    "2", // 283 (10.09%)
    "1", // 222 (7.92%)
    "10", // 220 (7.85%)
    "12", // 61 (2.18%)
    "26", // 31 (1.11%)
    "25", // 17 (0.61%)
    "17", // 4 (0.14%)
  ]),
  display_name: z.string(),
  // undefined: 1_188 (42.37%), defined 1_616 (57.63%)
  raw_value: z
    .union([
      // string samples: 1_570 (97.15%)
      // format numeric: 229 (14.59%)
      z.string(),
      // array samples: 46 (2.85%)
      z.array(
        // format numeric: 2_608 (100.00%)
        z.string()
      ),
    ])
    .optional(),
  value: z.union([
    // string samples: 2_756 (98.29%)
    // format integer: 382 (13.86%)
    z.string(),
    // array samples: 48 (1.71%)
    z.array(
      // format numeric: 2_610 (100.00%)
      z.string()
    ),
  ]),
  varies_by_app_group: z.literal(false),
});
